module.exports = __webpack_public_path__ + "static/media/valor2.1b264199.png";